<template>
  <div
    class="flex items-center justify-center bg-danger-500 p-2 font-medium text-pretty text-white"
    :class="[billing.attributes.invoice_overdue_urgent ? 'h-75' : '']"
  >
    <span
      v-if="billing.attributes.invoice_overdue_note"
      v-html="billing.attributes.invoice_overdue_note"
    ></span>
    <span v-else>{{ $t('client.labels.invoice_overdue') }}</span>
    <b-modal
      :can-cancel="[]"
      :model-value="invoice_overdue_big_show"
    >
      <Modal
        :has_parent="false"
        :is_cancel="false"
        :is_small="false"
        @actionPrimary="hideModal"
      >
        <template #title>
          {{ $t('client.labels.invoice_overdue_title') }}
        </template>
        <template #content>
          <div
            v-if="billing.attributes.invoice_overdue_note"
            v-html="billing.attributes.invoice_overdue_note"
          ></div>
          <span v-else>{{ $t('client.labels.invoice_overdue') }}</span>
        </template>
        <template #ButtonPrimary> Ok! </template>
      </Modal>
    </b-modal>
  </div>
</template>

<script setup>
import { ref } from 'vue';

const props = defineProps({
  billing: { type: Object, required: true },
});

const invoice_overdue_big_show = ref(false);

const hidden = sessionStorage.getItem('invoice_overdue_big_hidden');

if (props.billing.attributes.invoice_overdue_urgent && (_.isNil(hidden) || !hidden)) {
  invoice_overdue_big_show.value = true;
}

const hideModal = () => {
  invoice_overdue_big_show.value = false;
  sessionStorage.setItem('invoice_overdue_big_hidden', true);
};
</script>
